import r from"@babel/runtime-corejs3/core-js-stable/array/from";import e from"@babel/runtime-corejs3/core-js-stable/set";var o=function(o){var t=!o||o instanceof Array&&!o.length?[]:o;return r(new e(t instanceof Array?t:[t]))};export{o as sanitizeErrors};
//# sourceMappingURL=sanitizeErrors.js.map
